export default __webpack_public_path__ + "static/media/david.f1648c6a.jpg";